import Image from "next/image";

import { useTranslation } from "@flare/i18n";
import { Button, Heading, Icon, Text } from "@flare/ui/components";

import { BackButton } from "../components/back-button";
import { Footer } from "../components/footer";
import { StepContainer } from "../components/step-container";
import { StepContent } from "../components/step-content";

import { LssIntroDialogTrigger } from "./components/lss-intro-dialog/lss-intro-dialog-trigger";
import { LssIntroDrawerTrigger } from "./components/lss-intro-dialog/lss-intro-drawer-trigger";

export default function LssIntro() {
  const { t } = useTranslation();

  const lssTips = [
    t("FUNNEL_STEP_LSS_INTRO_ANSWER_ONE"),
    t("FUNNEL_STEP_LSS_INTRO_ANSWER_TWO"),
    t("FUNNEL_STEP_LSS_INTRO_ANSWER_THREE"),
  ];

  return (
    <>
      <StepContainer>
        <StepContent className="px-sp-0">
          <div className="px-sp-5 md:px-sp-7">
            <BackButton />
            <div className="mx-auto flex max-w-screen-sm flex-col justify-center py-sp-5 md:py-sp-8">
              <Heading className="mb-sp-2 md:max-w-[65%]">
                {t("FUNNEL_STEP_LSS_INTRO_TITLE")}
              </Heading>
              <Image
                src="/next/images/funnel/lss-intro.jpg"
                alt={t("FUNNEL_STEP_LSS_INTRO_IMG_ALT")}
                width={600}
                height={320}
                className="my-sp-6 w-full rounded-lg md:my-sp-8"
              />
              <div className="my-sp-3 flex flex-col gap-sp-5">
                {lssTips.map((text, index) => (
                  <div key={text} className="flex items-center gap-sp-4">
                    <div className="flex size-s-7 shrink-0 items-center justify-center rounded-full border border-[--color-primary]">
                      <Text variant="body1-highlight">{`0${index + 1}`}</Text>
                    </div>
                    <Text>{text}</Text>
                  </div>
                ))}
              </div>

              <div className="mt-sp-6 rounded-xl bg-main md:mt-sp-8">
                <div className="flex flex-col gap-sp-2 border-b-2 border-primary px-sp-5 py-sp-6">
                  <Text>{t("FUNNEL_STEP_LSS_INTRO_PRICING_TITLE")}</Text>
                  <div className="flex flex-row items-end gap-sp-0.5">
                    <Text variant="body1-highlight" className="pb-sp-2">
                      $
                    </Text>
                    <Heading variant="h1" className="pt-sp-0.5" as="h6">
                      49.00
                    </Heading>
                  </div>
                </div>
                <div className="hidden md:flex">
                  <LssIntroDialogTrigger>
                    <button
                      type="button"
                      className="flex w-full items-center justify-between px-sp-5 py-sp-7"
                    >
                      <Text>{t("FUNNEL_STEP_LSS_INTRO_PRICING_CTA")}</Text>
                      <Icon name="arrow-right" size="md" />
                    </button>
                  </LssIntroDialogTrigger>
                </div>

                <div className="flex md:hidden">
                  <LssIntroDrawerTrigger>
                    <button
                      type="button"
                      className="flex w-full items-center justify-between px-sp-5 py-sp-7"
                    >
                      <Text>{t("FUNNEL_STEP_LSS_INTRO_PRICING_CTA")}</Text>
                      <Icon name="arrow-right" size="md" />
                    </button>
                  </LssIntroDrawerTrigger>
                </div>
              </div>

              <Text
                className="mt-sp-8 text-[--color-typography-disabled] md:mt-[128px]"
                alignment="center"
                variant="body2"
              >
                {t("FUNNEL_STEP_LSS_INTRO_NOTICE")}
              </Text>
            </div>
          </div>

          <div className="fixed bottom-sp-0 z-10 w-full justify-center border-t border-primary bg-surface p-sp-4 px-sp-5 md:static md:flex md:pb-sp-1 md:pt-sp-4">
            <Button
              type="submit"
              size="lg"
              className="md:max-w-screen-sm"
              fullWidth
            >
              {t("FUNNEL_STEP_LSS_INTRO_CTA")}
            </Button>
          </div>
        </StepContent>
        <Footer />
      </StepContainer>
    </>
  );
}
